import { api } from "..";
import { QueryProps } from "@/types/Api";
import { AppSettingsAll, VisibleAppSettings } from "./types";

export async function getAppSettings(
  props: QueryProps
): Promise<AppSettingsAll> {
  const res = await api.client.get("/app-settings", { signal: props.signal });
  return res.data;
}

export async function getVisibleAppSettings(
  props: QueryProps
): Promise<VisibleAppSettings> {
  const res = await api.client.get("/app-settings/visible", {
    signal: props.signal,
  });
  return res.data;
}
